import React from 'react';

interface DefinitionRowProps {
    icon: React.ReactNode;
    label: string;
    tag: string;
    description: string;
}

const DefinitionRow: React.FC<DefinitionRowProps> = ({ icon, label, tag, description }) => (
    <div className="flex w-full flex-col gap-0.5">
        <div className="flex w-full items-center gap-0.5">
            <div className="flex min-w-0 flex-1 items-center gap-2">
                <span className="flex size-[13px] shrink-0 items-center justify-center text-[var(--malachite-text-primary)]">
                    {icon}
                </span>
                <p className="whitespace-nowrap font-medium text-sm text-[var(--malachite-text-primary)] tracking-[0.14px]">
                    {label}
                </p>
            </div>
            <p className="whitespace-nowrap text-right font-medium text-xs text-[var(--malachite-text-muted)] tracking-[0.12px]">
                {tag}
            </p>
        </div>
        <div className="flex w-full items-center pl-[21px]">
            <p className="flex-1 text-xs text-[var(--malachite-text-muted)] leading-[1.6]">{description}</p>
        </div>
    </div>
);

export default DefinitionRow;
